// extracted by mini-css-extract-plugin
export default {"wrapper":"Feature_wrapper__-JkAn","title":"Feature_title__QV-+o","grid":"Feature_grid__RzgS7"};